import React from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import Cookies from "js-cookie";

import {
    InitialWrap,
    NavigationBarContainer,
    NavigationItemsWrap,
    SalesHamburger,
} from "../common/salesModeLayout.styles";
import { ReactComponent as KudaLogo } from "../../../AuthenticatedApp/layout/common/icons/kuda-logo.svg";
import { ReactComponent as LogoutIcon } from "../../../AuthenticatedApp/layout/common/icons/sign-out.svg";
import { getInitials, logout } from "../../../../utils/utilityFunctions";

export const navigationItems = [
    {
        title: "Inventory",
        link: "/sales/catalogue",
    },
    {
        title: "Order History",
        link: "/sales/order-history",
    },
];

const TopNavigation = ({ handleToggleMobileNav }) => {
    const history = useHistory();
    const handleSignOut = () => {
        logout();
        window.location.reload();
        history.push("/login");
    };

    const groupName = Cookies.get("groupName");

    return (
        <NavigationBarContainer>
            <Link to="/sales/catalogue">
                <KudaLogo />
            </Link>
            <NavigationItemsWrap>
                {navigationItems.map(({ title, link }) => (
                    <NavLink
                        to={link}
                        className="sales__nav-item"
                        activeClassName="sales__nav-item-active"
                        key={title}
                    >
                        <p>{title}</p>
                    </NavLink>
                ))}
            </NavigationItemsWrap>
            <div className="sales__nav-right-wrap">
                <InitialWrap>
                    <div className="sales__nav-initial-inner">
                        <p>{groupName ? getInitials(groupName) : ""}</p>
                    </div>
                </InitialWrap>
                <div className="sales_nav-logout-wrap" onClick={handleSignOut}>
                    <LogoutIcon />
                    <p>Sign Out</p>
                </div>
            </div>
            <SalesHamburger onClick={() => handleToggleMobileNav(true)}>
                <div className="kuda-hamburger--inner"></div>
            </SalesHamburger>
        </NavigationBarContainer>
    );
};

export default TopNavigation;
